<div class="uploader">
  <div class="uploader-title" [innerHtml]="title"></div>
  <div appDropzone class="uploader-dropbox" (filesChanged)="onFilesChanged($event)">
    <app-svg-icon src="./assets/icons/img_upload.svg"></app-svg-icon>
    <div class="uploader-label">{{ label1 }}</div>
    <div class="uploader-label">{{ label2 }}</div>
    <input type="file" style="display: none" #file (change)="onFilesChanged($event.target.files)" accept=".pdf, .png, .jpg, .mp4, .wmv, .avi" />
    <button class="btn btn-outline-primary" (click)="file.click()">{{ buttonLabel }}</button>
  </div>
</div>
